import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './rss-feed.scss';
import {getPublishedDateLabel} from '../../../../helpers/dateTime';

export default class RssFeedItem extends Component {
  render() {
    const {title, description, link, thumbnail, pubDate, source} = this.props.item;

    return (
      <a rel="noopener noreferrer" href={link} target="_blank" className="glu-link rss-field">
        <div className="glu-content__section glu-content__separator glu-content__separator--inner">
          <div className="glu-flex glu-flex-row glu-flex-align-center">
            {thumbnail && (
              <div className="glu-flex-shrink">
                <img className="glu-widget__image" src={thumbnail} alt="" />
              </div>
            )}
            <div className="glu-flex-grow">
              <div className="rss-title">{title}</div>
              <div className="rss-description">{description}</div>
              <div className="rss-source-pub-date">
                Source: {source}, Published: {getPublishedDateLabel(pubDate)}
              </div>
            </div>
          </div>
        </div>
      </a>
    );
  }
}

RssFeedItem.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};
